import { useCallback } from 'react';
import {
  createCoral,
  createCoralBatch as createCoralBatchAPI,
  createChildFragments,
} from '../services/api';
import {
  CoralFormData,
  CreateCoralPayload,
  CreateCoralBatchPayload,
  CreateCoralBatchResponse,
  CoralResponse,
  BatchItem,
} from '../types';

export const useApi = () => {
  // New coral creation method
  const createCoralFragment = useCallback(
    async (formData: CoralFormData, rfid: string): Promise<CoralResponse> => {
      // Ensure species code is uppercase and valid format
      const speciesCode = formData.speciesCode.toUpperCase().trim();
      if (!/^[A-Z0-9_-]+$/.test(speciesCode)) {
        throw new Error(
          'Species code must contain only uppercase letters, numbers, underscores, and hyphens'
        );
      }

      // RFID validation is now handled server-side (must be 24 alphanumeric characters)
      const formattedRfid = rfid;

      const payload: CreateCoralPayload = {
        speciesCode,
        rfid: formattedRfid,
        cutDate: formData.cutDate,
        status: formData.condition,
      };

      console.log('Creating coral with validated payload:', payload);
      return await createCoral(payload);
    },
    []
  );

  // Batch coral creation method
  const createCoralBatch = useCallback(
    async (batchItems: BatchItem[], parentCoralId?: string): Promise<CreateCoralBatchResponse> => {
      if (batchItems.length === 0) {
        throw new Error('Batch cannot be empty');
      }

      // Use the first item's metadata for the entire batch
      const firstItem = batchItems[0];
      const formData = firstItem.metadata;

      // Ensure species code is uppercase and valid format
      const speciesCode = formData.speciesCode.toUpperCase().trim();
      if (!/^[A-Z0-9_-]+$/.test(speciesCode)) {
        throw new Error(
          'Species code must contain only uppercase letters, numbers, underscores, and hyphens'
        );
      }

      // Extract all RFIDs from the batch
      const rfidArray = batchItems.map((item) => item.rfid);

      const payload: CreateCoralBatchPayload = {
        speciesCode,
        rfid_array: rfidArray,
        cutDate: formData.cutDate || undefined,
        status: formData.condition,
      };

      console.log('Creating coral batch with validated payload:', payload);
      return parentCoralId
        ? await createChildFragments(parentCoralId, payload)
        : await createCoralBatchAPI(payload);
    },
    []
  );

  return {
    // createChild,
    createCoralFragment,
    createCoralBatch,
  };
};

export default useApi;
